module.exports = __webpack_public_path__ + "static/img/FJ@3x.63e404e8.png";